const SocketScreens = {
  CHAT: 'CHAT',
  ADMINCHAT: 'ADMINCHAT',
  APPOINTMENT: 'APPOINTMENT',
  ADMIN_APPOINTMENT: 'ADMIN_APPOINTMENT',
};

export default SocketScreens;
